import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'dynamic-skeleton-loading',
  styleUrl: 'dynamic-skeleton-loading.css',
})
export class DynamicSkeletonLoading {
  @Prop() useMiddleRow: boolean = false;
  render() {
    return (
      <div class="mt-4">
        <div>
          <skeleton-rect height="lg"></skeleton-rect>
        </div>
        {this.useMiddleRow && (
          <div class="mt-2">
            <skeleton-rect height="sm" width="half"></skeleton-rect>
          </div>
        )}
        <div class="mt-2">
          <skeleton-rect height="lg"></skeleton-rect>
        </div>
      </div>
    );
  }
}
